export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

// Parens escaped so the same source works in HTML `pattern`.
export const PHONE_PATTERN = /^\+?[0-9\s\(\)\-.]{7,20}$/

export function isValidPhoneNumber(value: string): boolean {
  if (!PHONE_PATTERN.test(value)) return false

  const digitCount = value.replace(/\D/g, '').length
  return digitCount >= 7 && digitCount <= 15
}

export type FormFieldToValidate = {
  blockType?: string
  label?: unknown
  name?: string
  required?: boolean
}

export function validateFormFieldValues(
  fields: FormFieldToValidate[],
  values: Record<string, boolean | number | string>,
  getFieldLabel: (field: FormFieldToValidate) => string,
): Record<string, string> {
  return fields.reduce<Record<string, string>>((acc, field) => {
    if (!field.name) return acc

    const value = values[field.name]
    const textValue = typeof value === 'string' ? value.trim() : ''
    const isRequired = Boolean(field.required)
    const fieldLabel = getFieldLabel(field) || 'This field'

    if (isRequired) {
      const missingValue = field.blockType === 'checkbox' ? value !== true : textValue.length === 0

      if (missingValue) {
        acc[field.name] = `${fieldLabel} is required.`
        return acc
      }
    }

    if (field.blockType === 'email' && textValue && !EMAIL_PATTERN.test(textValue)) {
      acc[field.name] = 'Enter a valid email address.'
      return acc
    }

    if (field.blockType === 'phone' && textValue && !isValidPhoneNumber(textValue)) {
      acc[field.name] = 'Enter a valid phone number.'
      return acc
    }

    if (field.blockType === 'number' && textValue && Number.isNaN(Number(textValue))) {
      acc[field.name] = 'Enter a valid number.'
    }

    return acc
  }, {})
}
